module.exports = __webpack_public_path__ + "img/0.0_Overview.0d5f8ff2.jpg";